import React from 'react'

import Button from '@components/Content/Button/Button'
import Section from '@components/Section/Section'
import SectionContent from '@components/Section/SectionContent'
import SectionTitle from '@components/Section/SectionTitle'

import { StyledTitleType } from '@contracts/Components/StyledTitle'

import useNewsArchiveLink from '@hooks/useNewsArchiveLink'
import useNewsPosts from '@hooks/useNewsPosts'

import * as styles from './FeaturedPostsVerticalSection.module.scss'
import NewsPostCard from './NewsPostCard'

const FeaturedPostsVerticalSection = () => {
	const featuredPosts = useNewsPosts({ featuredOnly: true })
	const newsArchiveLink = useNewsArchiveLink()

	const sectionTitle: StyledTitleType = [
		{
			styledText: {
				text: 'Featured',
				isYellow: false,
				isThin: false,
				isSplit: false,
			},
		},
		{
			styledText: {
				text: 'News',
				isYellow: true,
				isThin: false,
				isSplit: false,
			},
		},
	]

	return (
		<Section className={styles.section} containerClassName={styles.container} noTopPadding>
			<div>
				<SectionTitle title={sectionTitle} className={styles.title} />
				<Button
					data={{
						buttonType: 'internal',
						label: 'View all news',
						internalLink: {
							link: newsArchiveLink,
						},
					}}
					style="hollow"
				/>
			</div>
			<SectionContent className={styles.posts}>
				{featuredPosts.map((post) => {
					return <NewsPostCard key={post.id} post={post} className={styles.post} style="horizontal" />
				})}
			</SectionContent>
		</Section>
	)
}

export default FeaturedPostsVerticalSection
